<template>
  <div class="rangebox">

    <van-nav-bar class="vannavbar" title="范围选择" left-text="" right-text="确定" left-arrow @click-left="onClickLeft" @click-right="onClickRight"/>
    
    <div class="range-nav">
      <p v-if="items.length == 1">{{organName}}</p>
      <div v-else class="scroll-wrapper">
        <cube-scroll ref="scroll" :data="items" direction="horizontal" class="horizontal-scroll-list-wrap">
          <ul class="list-wrapper">
            <li v-for="(item,i) in items" :key="i" class="list-item" :class="items.length-1 > i ? 'active' : ''" @click="black(i,item)">{{ item.name }}<span v-if="items.length-1 > i">></span></li>
          </ul>
        </cube-scroll>
      </div>

    </div>
    <div class="range-box">
      <div class="range-all" v-show="isAll">
        <cube-checkbox v-model="checkedAll" position="right" @input="userAll">全部</cube-checkbox>
      </div>
      <div class="range-list" v-for="(item, index) in getList" :key="index">
        <van-cell :title="item.deptName" is-link v-if="checkedAll == true"/>
        <van-cell :title="item.deptName" is-link v-else @click="next(item)"/>
      </div>
    </div>
    <div class="range-checkList" v-show="isShow">
      <div class="range-all">
        <div class="range-user">
          <img src="../../assets/img/user.png" alt="">
        </div>
        <div class="range-check">
          <cube-checkbox v-model="depchecked" position="right" @input="depuserAll">全部</cube-checkbox>
        </div>
      </div>
      <div ref="checkGroup">
        <cube-checkbox-group v-model="checkList" @checked="optUserList" @cancel-checked="isoptUser">
          <div class="range-all alldep" v-for="(item, index) in staffDat" :key="index">
            <div class="range-user">
              <img src="../../assets/img/user.png" alt="">
            </div>
            <div class="range-check">
              <cube-checkbox position="right" :option="{label: item.personName, value: item.userId}"></cube-checkbox>
            </div>
          </div>
        </cube-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { unique,unique1 } from '@/utils/utils.js'
import { getOrganizeTree } from '@/api/resetApi.js'
export default {
  name: 'range',
  data() {
    return {
      isNext: false,
      isShow: false,
      isAll: true,
      checkedAll: false,
      depchecked: false,
      checkList: [],
      checked: false,
      organName: '',
      getList: [],
      getData: [],
      staffDat: [],
      getChildData: [],
      getUserData: [],
      items: [],
      getNavData: [],
      parentType:null,
      parentTypeText:null
    }
  },
  created(){
    this.parentType = this.$route.query.type
    this.parentTypeText = this.$route.query.typeText
    this.getRange()
  },
  methods: {
    // 获取公司所有部门和职员有信息
    async getRange() {
      const res = await getOrganizeTree()
      console.log('countReport=',res)
      try {
        if (res.data.code === 200) {
          this.organName = res.data.data.organName
          this.items.push({id:res.data.data.organId,name:this.organName})
          console.log('this.items=',this.items)
          this.getList = res.data.data.deptMenuBos
          this.getData = res.data.data.deptMenuBos
          this.getNavData = res.data.data
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },

    // 后退选择部门
    black(num,obj) {
      this.checkedAll = false
      this.isNext = false
      let datalist = []
      let data = this.getNavData.deptMenuBos
      if (this.items.length-1 > num) {
        if (num == 0) {
          this.isAll = true
          this.getData = this.getNavData
          this.isShow = false;
          this.getList = data
          this.items.splice(1)
        } else {
          this.items.splice(num+1)
          for (let i=0; i<data.length; i++) {
            if (data[i].deptId == obj.id) {
              this.getData = data
              this.getList = data[i].childDeptVos
              this.staffDat = data[i].deptUserVos
              this.rangeAll();
              return
            } else {
              datalist = data[i].childDeptVos
              this.blackloop(datalist,obj)
            }
          }
        }
        this.rangeAll();
      } else {
        return
      }
    },
    blackloop(data,obj) {
      let childdata = data
      for (let i=0; i<childdata.length; i++) {
        if (childdata[i].childDeptVos.length > 0) {
          if (childdata[i].deptId == obj.id) {
            this.getList = childdata[i].childDeptVos
            this.staffDat = childdata[i].deptUserVos
            return
          } else {
            this.isAll = true
            this.blackloop(childdata[i].childDeptVos,obj)
          } 
        }
      }
    },

    // 判断是否全选状态
    rangeAll() {
      this.$nextTick(() => {
        let rangeAll = this.$refs.checkGroup.getElementsByClassName("alldep")
        let checked = this.$refs.checkGroup.getElementsByClassName("cube-checkbox_checked")
        if (rangeAll.length == checked.length) {
          console.log('depchecked')
          this.depchecked = true
        } else {
          this.depchecked = false
        }
        console.log('rangeAll=',rangeAll.length)
        console.log('checked=',checked.length)
      })
    },

    // 前进选择部门
    next(data) {
      let list = []
      if (data.deptUserVos.length == 0 && data.childDeptVos.length == 0) {
        this.$createToast({
          txt: '此部门下暂无下级部门及人员',
          type: 'error'
        }).show()
      } else {
        this.depchecked = false
        this.getList = data.childDeptVos
        this.getData = data
        this.staffDat = data.deptUserVos
        if (this.getData.checkedAll == true) {
          this.checkedAll = true
        } else {
          this.checkedAll = false
        }
        console.log('data11111=',this.getData)
        list.push({id:this.getData.deptId,name:this.getData.deptName})
        this.items = this.items.concat(list)
        console.log('items=',this.items)
        if (data.childDeptVos.length === 0) {
          this.isAll = false;
        }
        if (data.deptUserVos.length == 0) {
          this.isShow = false
        } else {
          this.isShow = true;
          this.rangeAll();
        }
      }
    },

    // 返回
    onClickLeft() {
      this.$router.push({
        name: 'SalesIndex',
        query:{
          type:this.parentType,
          typeText:this.parentTypeText
        }
      })
    },
    // 确定后带入参跳转到统计报告
    onClickRight() {
      console.log('getChildData=',this.getChildData)
      if(this.getChildData.length == 0){
        this.$createToast({
          txt: '请选择人员',
          type: 'error'
        }).show()
      }else{
        this.$router.push({
          name: 'SalesIndex',
          query:{
            type:this.parentType,
            typeText:this.parentTypeText
          }
        })
        // this.$store.commit('report/changeNum',this.getChildData)
        this.$store.state.report.getChildData = this.getChildData
        this.$store.state.report.checkList = this.checkList
      }
    },

    /*======= 获取选择单个职员信息 ======*/
    optUserList(val) {
      let that = this
      let data = []
      for(let i=0; i<that.staffDat.length; i++) {
        if (that.staffDat[i].userId === val) {
          data.push({name:that.staffDat[i].personName,id:that.staffDat[i].userId});
        }
      }
      // console.log('data',data)
      that.getChildData = unique(that.getChildData.concat(data))
      // console.log('11111',that.getChildData)
    },
    isoptUser(val) {
      // console.log('val1111=', val)
      let that = this
      for(let i=0; i<that.getChildData.length; i++) {
        if (that.getChildData[i].id === val) {
          that.getChildData.splice(i,1)
          // data.push({name:that.staffDat[i].personName,id:that.staffDat[i].userId});
        }
      }
      // console.log('11111',that.getChildData)
    },

    /*======= 获取部门所有职员信息 ======*/
    depuserAll(val) {
      if (val === true) {
        // this.checkedAll = val
        this.depchecked = val
        this.deploop(1)
        console.log('checkList1=', this.checkList)
      } else {
        // this.checkedAll = val
        this.depchecked = val
        this.deploop(2)
        this.checkList = []
        console.log('val=', val)
        console.log('checkList2=', this.checkList)
      }
      this.getChildData.forEach(item=>{
        if(item.name.length > 2){
          item.name = item.name.slice(-2);
        }
      })
      // console.log('getChildData111=', this.getChildData)
    },
    deploop(val) {
      let that = this
      let data = []
      // console.log('staffDat=', this.staffDat)
      for(let i=0; i<that.staffDat.length; i++) {
        // that.getChildData.push({name:that.staffDat[i].personName,id:that.staffDat[i].userId});
        data.push({name:that.staffDat[i].personName,id:that.staffDat[i].userId});
        that.checkList.push(that.staffDat[i].userId)
      }
      // console.log('data=', data)
      if (val === 1) {
        this.getChildData = data.concat(this.getChildData)
      } else {
        for (let i=0; i<that.getChildData.length; i++) {
          for (let j=0; j<data.length; j++) {
            if (that.getChildData[i].id == data[j].id) {
              that.getChildData.splice(i,1)
            }
          }
        }
      }
      that.getChildData = unique(that.getChildData)
      // console.log('getChildData=', that.getChildData)
    },

    /*======= 获取公司所有职员信息 ======*/
    userAll(val) {
      // this.getChildData = []
      // this.checkList = []
      if (val === true) {
        this.getData.checkedAll = true
        this.checkedAll = val
        this.depchecked = val
        this.checked = val
        this.allloop()
        this.getChildData = unique(this.getChildData)
        this.checkList = unique1(this.checkList)
        console.log('getData=', this.getData)
        console.log('getChildData=', this.getChildData)
        console.log('checkList=', this.checkList)
      } else {
        this.getData.checkedAll = false
        console.log('getData=', this.getData)
        this.checkedAll = val
        this.depchecked = val
        this.checkList = []
        this.getChildData = []
        this.getUserData = []
        // console.log('checkList=', this.checkList)
      }
      this.getChildData.forEach(item=>{
        if(item.name.length > 2){
          item.name = item.name.slice(-2);
        }
      })
      // console.log('val=',val)
    },
    allloop() {
      let that = this
      let data = []
      // console.log('getData=', that.getData)
      if (that.getData.length > 0) {
        for(let i=0; i<that.getData.length; i++) {
          for (let j=0; j<that.getData[i].deptUserVos.length; j++) {
            that.getChildData.push({name:that.getData[i].deptUserVos[j].personName,id:that.getData[i].deptUserVos[j].userId});
            that.checkList.push(that.getData[i].deptUserVos[j].userId)
          }
          if (that.getData[i].childDeptVos.length > 0) {
            data = that.getData[i].childDeptVos
            that.childloop(data)
          }
        }
      } else {
        for (let j=0; j<that.getData.deptUserVos.length; j++) {
          that.getChildData.push({name:that.getData.deptUserVos[j].personName,id:that.getData.deptUserVos[j].userId});
          that.checkList.push(that.getData.deptUserVos[j].userId)
        }
        if (that.getData.childDeptVos.length > 0) {
          data = that.getData.childDeptVos
          that.childloop(data)
        }
      }
      that.getChildData = unique(that.getChildData)
      // console.log('getChildData111=', that.getChildData)
    },
    childloop(data) {
      let that = this
      let list = []
      for(let i=0; i<data.length; i++) {
        if (data[i].deptUserVos.length > 0) {
          for (let j=0; j<data[i].deptUserVos.length; j++) {
            that.getChildData.push({name:data[i].deptUserVos[j].personName,id:data[i].deptUserVos[j].userId});
            that.checkList.push(data[i].deptUserVos[j].userId)
          }
        }
        list = data[i].childDeptVos
        that.childloop(list)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.rangebox {
  position: absolute;
  height: 100%;
  width: 100%;
  top:0;
  left: 0;
  overflow-y: auto;
  background-color: #F7F7F7;
}
.vannavbar {
  position: fixed;
  z-index: 10;
  right: 0;
  left: 0;
  width: 100%;
}
.range-nav {
  padding: 45px 10px 0;
  height: 40px;
  text-align: left;
  line-height: 40px;
  font-size: 14px;
  background: #fff;
}
.range-box {
  background: #fff;
  .range-all {
    border-top: 1px solid #EFEFEF;
    height: 40px;
    padding: 0 10px;
    font-size: 14px;
    .cube-checkbox {
      padding: 0 9px 0 2px;
    }
  }
  .range-list {
    border-top: 1px solid #EFEFEF;
    text-align: left;
  }
}
.range-checkList {
  margin-top: 10px;
  background: #fff;
  .range-all {
    display: flex;
    border-top: 1px solid #EFEFEF;
    height: 40px;
    padding: 0 10px;
    font-size: 14px;
    .range-user {
      flex: 0 0 30px;
      align-self: center;
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
    }
    .range-check {
      flex: 1;
      margin-left: 5px;
      align-self: center;
      .cube-checkbox {
        padding: 0 9px 0 2px;
      }
    }
  }
}
.active {
  color: #2574F6;
}
.horizontal-scroll-list-wrap  .list-item{
  display: inline-block;
}
.horizontal-scroll-list-wrap .list-wrapper{
  white-space: nowrap;
}
.horizontal-scroll-list-wrap .cube-scroll-content{
  display: inline-block
}
</style>
